/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * damage
 */
export interface StructureDamageEntry { 
    /**
     * primary Key
     */
    id?: number;
    /**
     * Structure damage id
     */
    structureDamageId?: number;
    /**
     * Structure id
     */
    structureInspectionId?: number;
    /**
     * On this date the damage was noted first time
     */
    entryDatetime?: string;
    /**
     * numericProperties
     */
    severityEntities?: string;
    /**
     * numericProperties
     */
    numericProperties?: string;
    /**
     * categories
     */
    categories?: string;
    /**
     * textProperties
     */
    textProperties?: string;
}

